import { EventEmitter } from "events";
import LMSDispatcher from "../../LMSDispatcher";
import * as ACTIONCONTANTS from "../../actions/ActionConstants";
interface ILoginSate {
  state: {
    access_token: null | string;
    expires_in: null | string;
    refreshExpiresIn: null | string;
    refresh_expires_in: null | string;
    refresh_token: null | string;
    token_type: null | string;
    upgraded: null | string;
    userName: null | string;
  };
}

class LoginStore extends EventEmitter implements ILoginSate {
  state: {
    access_token: "";
    expires_in: null;
    refreshExpiresIn: null;
    refresh_expires_in: null;
    refresh_token: null;
    token_type: null;
    upgraded: null;
    userName: "";
  };
  constructor() {
    super();
    this.state = {
      access_token: "",
      expires_in: null,
      refreshExpiresIn: null,
      refresh_expires_in: null,
      refresh_token: null,
      token_type: null,
      upgraded: null,
      userName: "",
    };

    LMSDispatcher.register((e: any) => {
      switch (e.type) {
        case ACTIONCONTANTS.LOGIN_DETAILS:
          if (e.payload && e.payload.data)
            Object.assign(this.state, e.payload.data);
          this.emit("change", this.state);
          break;
      }
    });
  }
}

const loginFormStore = new LoginStore();

export default loginFormStore;
